import { BrowserRouter, Route, Routes } from "react-router-dom";
import { HomeLayout } from "site/ui";
import { siteRoutes } from "./app/utils";
import { useUser } from "hooks";

function SiteApp() {
  const { contactUse } = useUser();
  return (
      <BrowserRouter>
        <Routes>
           <Route element={
              <HomeLayout {...{
                async onCreateContactMessage(contactInfo) {
                  const res = await contactUse(contactInfo)
                  return Boolean(res)
                },
              }}/>
            }
          >
            {siteRoutes.map((route, index) => {
              return (
                <Route
                  path={route.path}
                  key={route.path + "---" + index}
                  element={<route.Component />}
                />
              );
            })}
          </Route>
        </Routes>
      </BrowserRouter>
  );
}

export default SiteApp;
